import { css } from "@emotion/react";
import { kitText } from "../../styles";

export const styles = {
  section: css`
    display: flex;
    flex-direction: column;
    gap: var(--spacing-8);
    align-items: flex-start;
    width: 100%;
  `,
  thumb: css`
    color: var(--color-tertiary);
    --icon-fill-color: var(--color-tertiary);
  `,
  thumbSelected: css`
    color: var(--color-splash-primary);
    --icon-fill-color: var(--color-splash-primary);
  `,
  feedbackButtons: css`
    display: flex;
  `,
  details: css`
    margin-bottom: var(--spacing-24);
  `,
  completedMessage: css`
    ${kitText.variant.body}
  `
};
